












import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import api from '@api'

@Component
export default class extends Vue {
    @Prop()
    dialogFormVisible!: boolean

    @Prop()
    rowItem!: any

    url = ''
    srcList:string[] = []

    @Watch('dialogFormVisible')
    onDialogVisible() {
        this.url = this.rowItem.repaymentVoucher
        this.srcList = [this.url]
    }

    // created(): void {
    //     this.url = 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'
    //     this.srcList = [this.url]
    // }

    onClose() {
        // debugger;
        this.$emit('close', false)
    }
}
